<template>
  <div class="overtime_application">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  data() {
    return {
      form: {
        name: ""
      }
    };
  },
  methods: {
  }
};
</script>

<style lang="scss" scoped>
@import "../../index.scss";

.title {
  a {
    font-size: 12px;
    margin-right: 20px;
  }
  .router-link-active {
    font-size: 20px;
    color: #333 !important;
  }
}
</style>
